import komplexbridgeService from "../services/komplexbridge.service";

const handlers = {
    komplexbridge: {
        session: {
            set: "komplexbridge_session_set"
        }
    }
}

const initVuexState = function(state) {
    state.komplexbridge = {
        session: null
    };
}

const initGetters = function(getters) {
    getters.komplexbridge = (state => state.komplexbridge);
}

const initActions = function(actions) {
    actions[handlers.komplexbridge.session.set] = ({ commit }, session) => commit(handlers.komplexbridge.session.set, session);
}

const initMutations = function(mutations) {
    mutations[handlers.komplexbridge.session.set] = (state, session) => state.komplexbridge.session = session;
}

const initAppState = function(appState, store) {
    appState.komplexbridge = {
        session: {
            get: () => store.getters.komplexbridge.session,
            open: async options => {
                const session = await komplexbridgeService.openSession(options);
                store.dispatch(handlers.komplexbridge.session.set, session);
            },
            openDemo: async options => {
                const session = await komplexbridgeService.openDemoSession(options);
                store.dispatch(handlers.komplexbridge.session.set, session);
            },
            close: async () => {
                store.getters.komplexbridge.session && await komplexbridgeService.closeSession();
                store.dispatch(handlers.komplexbridge.session.set, null);
            }
        }
    }
}

export default {
    initVuex(vuexState, getters, actions, mutations) {
        initVuexState(vuexState);
        initGetters(getters);
        initActions(actions);
        initMutations(mutations);
    },
    initAppState(appState, store) {
        initAppState(appState, store);
    }
};


// WEBPACK FOOTER //
// ./_common/data/komplexbridge.js